import React, { useEffect, useRef, useState } from "react"
import PropTypes from "prop-types"
import { Col, Modal, Row } from "reactstrap"
import { AvField, AvForm } from "availity-reactstrap-validation"

const DynamicModalWithInput = props => {
  const [textInForm, setTextInForm] = useState("")
  const formRef = useRef()

  useEffect(() => {
    if (!props.isOpen) {
      setTextInForm("")
    }
  }, [props.isOpen])

  const actionForm = () => {
    if (props.what !== "delete") {
      props.action(textInForm, formRef)
    } else {
      props.action(textInForm, formRef)
    }
  }

  return (
    <Modal
      isOpen={props.isOpen}
      toggle={props.toggle}
      scrollable={true}
      backdrop={"static"}
      id="staticBackdrop"
      centered
    >
      <div className="modal-header">
        <h5 className="modal-title" id="staticBackdropLabel">
          {props.header || ""}
        </h5>
        <button
          type="button"
          className="btn-close"
          onClick={() => props.toggle()}
          aria-label="Close"
        ></button>
      </div>
      <div className="modal-body">
        <Row>
          <Col sm={12}>
            {props.what !== "delete" ? (
              <p>{props.text}</p>
            ) : (
              <p>
                {props.text ||
                  <React.Fragment>
                    To confirm {props.what}, type <strong>{props.word}</strong> in
                    the field.
                  </React.Fragment>
                }
              </p>
            )}
            {props.isInput && <>
              <AvForm className="mb-3" ref={formRef}>
                <AvField
                  name="text"
                  placeholder="Description..."
                  // value={this.props.offer?.name || ""}
                  type="text"
                  errorMessage="Enter description"
                  className="form-control"
                  value={textInForm}
                  validate={{
                    required: { value: true },
                    minLength: { value: 3, errorMessage: "Min 3 letter" }
                  }}
                  onChange={e => setTextInForm(e.target.value)}
                  id="__text_desc__"
                />
              </AvForm>
              {/*<input*/}
              {/*  className="form-control mb-3"*/}
              {/*  type="text"*/}
              {/*  value={textInForm}*/}
              {/*  onChange={e => setTextInForm(e.target.value)}*/}
              {/*/>*/}
            </>}
          </Col>
          {props.alertText && (
            <Col sm={12}>
              <div
                className={`alert alert-${props.alertColor} mb-1`}
                role="alert"
              >
                {props.alertText}
              </div>
            </Col>
          )}
        </Row>
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-light"
          onClick={() => props.toggle()}
        >
          Close
        </button>
        {props.additionalButton &&
          <button
            type="button"
            className={`btn btn-${props.additionalButton.buttonColor || props.buttonColor}`}
            disabled={props.additionalButton.disabled || (props.isInput && textInForm.length < 3)}
            onClick={() => props.additionalButton.onClick(textInForm, formRef)}
          >
            {props.additionalButton.name}
          </button>
        }
        {props.what !== "delete" ? (
          <button
            type="button"
            className={`btn btn-${props.buttonColor}`}
            disabled={props.canDisableButtonConfirm ? (props.isInput && textInForm.length < 3) : false}
            onClick={() => actionForm()}
          >
            {props.buttonText}
          </button>
        ) : (
          <button
            type="button"
            className={`btn btn-${props.buttonColor}`}
            disabled={textInForm !== props.word}
            onClick={() => actionForm()}
          >
            Delete
          </button>
        )}
      </div>
    </Modal>
  )
}

DynamicModalWithInput.defaultProps = {
  alertColor: "primary",
  codeText: "delete",
  buttonColor: "danger",
  header: "Simple header",
  buttonText: "Apply",
  what: "deletion",
  word: "delete",
  isInput: true,
  canDisableButtonConfirm: true
}

DynamicModalWithInput.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func,
  header: PropTypes.string.isRequired,
  action: PropTypes.func,
  codeText: PropTypes.string.isRequired,
  alertText: PropTypes.node,
  alertColor: PropTypes.string.isRequired,
  buttonColor: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  what: PropTypes.string.isRequired,
  word: PropTypes.string.isRequired,
  text: PropTypes.string,
  applyType: PropTypes.string,
  additionalButton: PropTypes.any,
  isInput: PropTypes.bool,
  canDisableButtonConfirm: PropTypes.bool,
}

export default DynamicModalWithInput
